import { BrainCircuit } from "lucide-react";
import { Panel, PanelHeader, Chip } from "./primitives";
import { DataStatus } from "./DataStatus";

const PLANNED = ["Portfolio health scoring", "Concentration diagnostics", "Regime-aware explanations", "Guardian-linked recommendations"];

export const PortfolioBrain = () => (
  <Panel data-testid="portfolio-brain">
    <PanelHeader right={<DataStatus status="NOT DEPLOYED" pulse={false} />}>
      <span className="flex items-center gap-2"><BrainCircuit className="h-3.5 w-3.5 text-brass" /> Portfolio Brain</span>
    </PanelHeader>
    <div className="p-4">
      <p className="text-xs leading-relaxed text-fog-400">
        Portfolio Brain activates when agent intelligence services are deployed against real portfolio state.
        No simulated portfolio metrics are displayed.
      </p>
      <div className="mt-4 space-y-1.5">
        {PLANNED.map((p) => (
          <div key={p} className="flex items-center justify-between border-b border-white/[0.05] py-1.5 last:border-0">
            <span className="font-mono text-[11px] text-fog-400">{p}</span>
            <Chip tone="muted">Planned</Chip>
          </div>
        ))}
      </div>
    </div>
  </Panel>
);
